import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-placement-cell',
    templateUrl: './placement-cell.component.html',
    styleUrls: ['./placement-cell.component.scss']
})
export class PlacementCellComponent implements OnInit {
    src: string = '/assets/pdf/Placement 2024-25.pdf';
    title: string = 'Placement Cell';

    constructor() { }

    ngOnInit(): void {
    }

}
